export { sineInOut } from '@wix/wow-utils';
export function lerp(a, b, t) {
  return a * (1 - t) + b * t;
}
export function angleToRad(angle) {
  return (angle - 90) * Math.PI / 180;
}
const REVEAL_DURATION = 1500;
export function getEffectReveal(fn) {
  let _revealTime = performance.now();
  return t => {
    const p = (t - _revealTime) / REVEAL_DURATION;
    fn(p);
    if (p >= 1) {
      _revealTime = 0;
      return true;
    }
    return false;
  };
}
//# sourceMappingURL=motion.js.map